module.exports = require("core-js-pure/features/instance/slice");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/instance/slice.js
// module id = 547
// module chunks = 0 1